import { AccordionSummary, Typography, Hidden, IconButton, Button, Tooltip } from '@material-ui/core';
import { EditIconTwoTone } from '@room-match/shared-ui-components';
import { ReactNode } from 'react';
import {
  EditProfileMediaDocumentAccordionContainer,
  EditProfileAccordionSummaryLeft,
  EditProfileAccordionSummaryRight,
  EditProfileAccordionSummaryRightButtonContainer,
  EditProfileMediaDocumentAccordionDetails,
  EditProfileMediaProgressBarContainerLarge,
} from './EditProfileMediaDocumentAccordion.styles';
import { RepresentativesListItemProgressBar } from 'pages/Representatives/features/RepresentativesList/components/RepresentativesListItem/RepresentativesListItem.styles';
import { EditProfileProgressText } from '../EditProfileSideInfo/EditProfileSideInfo.styles';
import { getCompletionColor } from 'pages/Representatives/utils/getCompletionColor';
import { FileType } from 'shared/enums/FileType';
import { useEditProfileMediaDocuments } from '../../context/EditProfileMediaDocumentsProvider';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'shared/constants/ROUTES';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ProgressBar from 'shared/components/ProfileProgressBar/ProgressBar';

type EditProfileMediaDocumentAccordionProps = {
  type: FileType;
  header_icon: ReactNode;
  usedLength: number;
  maxLength: number;
  completeness: number;
  children: ReactNode;
  handleSetUploadedFiles?: (files: File[]) => void;
};

const EditProfileMediaDocumentAccordion = ({
  type,
  header_icon,
  maxLength,
  usedLength,
  completeness,
  children,
  handleSetUploadedFiles,
}: EditProfileMediaDocumentAccordionProps) => {
  const { handleSetAddModal } = useEditProfileMediaDocuments();
  const history = useHistory();

  const handleAddMediaClick = () => {
    handleSetAddModal(type, handleSetUploadedFiles);
  };

  const handleEditClick = () => {
    history.push(`${ROUTES.TALENT.MEDIA}/${type.toLowerCase()}s`);
  };

  return (
    <div style={{ marginBottom: 15 }}>
      <EditProfileMediaDocumentAccordionContainer square defaultExpanded>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <EditProfileAccordionSummaryLeft>
            {header_icon}
            <div>
              <Typography style={{ fontWeight: 600 }}>{type + 's'}</Typography>
              <Typography>
                {usedLength} of {maxLength} Used
              </Typography>
            </div>
          </EditProfileAccordionSummaryLeft>
          <EditProfileAccordionSummaryRight>
            <Hidden mdUp>
              <RepresentativesListItemProgressBar
                value={completeness}
                text={`${completeness}%`}
                completeness={completeness}
              />
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditClick();
                }}
                style={{ padding: 2, fontSize: 18 }}
              >
                <EditIconTwoTone color="primary" fontSize="inherit" />
              </IconButton>
              <IconButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddMediaClick();
                }}
                style={{ padding: 2, fontSize: 22 }}
              >
                <AddCircleOutlineIcon color="primary" fontSize="inherit" />
              </IconButton>
            </Hidden>
            <Hidden smDown>
              <EditProfileProgressText
                style={{ fontSize: 12, flex: 1, textAlign: 'end', marginTop: 10 }}
                progress={completeness}
              >
                {completeness}% Complete
              </EditProfileProgressText>
              <EditProfileMediaProgressBarContainerLarge>
                <ProgressBar
                  borderRadius={8}
                  percent={completeness || 0}
                  completeColor={getCompletionColor(completeness || 0)}
                />
              </EditProfileMediaProgressBarContainerLarge>
              <EditProfileAccordionSummaryRightButtonContainer>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditClick();
                  }}
                >
                  Edit
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddMediaClick();
                  }}
                >
                  Add {type}
                </Button>
              </EditProfileAccordionSummaryRightButtonContainer>
            </Hidden>
          </EditProfileAccordionSummaryRight>
        </AccordionSummary>
        <EditProfileMediaDocumentAccordionDetails>
          <div style={{ marginTop: 7, width: '100%', height: '100%', minWidth: 0 }}>{children}</div>
        </EditProfileMediaDocumentAccordionDetails>
      </EditProfileMediaDocumentAccordionContainer>
    </div>
  );
};

export default EditProfileMediaDocumentAccordion;
